import React, { useState, useEffect, useContext, useRef } from "react";
import "./Profile.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencilAlt } from "@fortawesome/free-solid-svg-icons";
import Profile_Vendor from "../profile-vendor/Profile_Vendor";
import Profile_Expert from "../profile-expert/Profile_Expert";
import Account_Created_Modal from "../../header/login/account-created-modal/Account_Created_Modal";
import { Context } from "../../../utils/context";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  GETCustomer,
  Update_Customer,
} from "../../../features/admin/auth/Slice";
import Select from "react-select";
import {
  AllState,
  AllDistrict,
  AllTaluka,
} from "../../../features/admin/common/Slice";
import { IDS } from "../../../utils/IDS";
import { useForm } from "react-hook-form";

const Profile = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const states = useSelector((state) => state?.common?.all_state);
  const districts = useSelector((state) => state?.common?.all_district);
  const talukas = useSelector((state) => state?.common?.all_taluka);

  const mapRef = useRef();
  const mapInstance = useRef(null);
  const markerRef = useRef(null);
  const searchInputRef = useRef(null);

  // const {
  //   formState: { errors },
  // } = useForm();

  useEffect(() => {
    dispatch(AllState());
  }, [dispatch]);

  const { userdata } = useContext(Context);
  const [isEditing, setIsEditing] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [profileImage, setProfileImage] = useState(
    "/assets/images/profile-icon.png",
  );
  const [profilePicFile, setProfilePicFile] = useState(null);
  const [errors, setErrors] = useState({});

  const selectStyles = {
    control: (base) => ({
      ...base,
      height: "45px",
      borderRadius: "30px",
      border: "1px solid #ddd",
      boxShadow: "none",
    }),
    indicatorSeparator: () => ({ display: "none" }),
    valueContainer: (base) => ({ ...base, padding: "0 20px" }),
  };

  const customerGet = useSelector(
    (state) => state?.auth?.login?.getCustomerData,
  );

  /* -------------------- FORM STATE -------------------- */
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile_number: "",
    whatsapp_no: "",
    state: "",
    state_id: null,
    district: "",
    district_id: null,
    taluka: "", // ✅ ADD
    taluqa_id: null, // ✅ ADD
    area: "",
    adhar_no: "",
    lat: "",
    long: "",
  });

  useEffect(() => {
    dispatch(GETCustomer());
  }, [dispatch]);

  useEffect(() => {
    if (formData.state_id) {
      dispatch(AllDistrict({ state_id: formData.state_id }));
    }
  }, [formData.state_id, dispatch]);

  useEffect(() => {
    if (customerGet) {
      setFormData({
        name: customerGet?.name || "",
        email: customerGet?.email || "",
        mobile_number: customerGet?.mobile_number || "",
        whatsapp_no: customerGet?.user_details?.whatsapp_no || "",
        adhar_no: customerGet?.adhar_no || "",
        lat: customerGet?.lat || "",
        long: customerGet?.long || "",
        state: customerGet?.user_details?.state
          ? {
              value: customerGet.user_details.state.id,
              label: customerGet.user_details.state.name,
            }
          : null,
        state_id: customerGet?.user_details?.state?.id || null,
        district: customerGet?.user_details?.district
          ? {
              value: customerGet.user_details.district.id,
              label: customerGet.user_details.district.name,
            }
          : null,
        district_id: customerGet?.user_details?.district?.id || null,
        // ✅ TALUKA PREFILL
        taluka: customerGet?.user_details?.taluqa
          ? {
              value: customerGet.user_details.taluqa.id,
              label: customerGet.user_details.taluqa.name,
            }
          : null,
        taluqa_id: customerGet?.user_details?.taluqa?.id || null,

        // ✅ AREA PREFILL
        area: customerGet?.user_details?.area || "",
      });

      // ✅ FIXED IMAGE LOGIC
      const img = customerGet?.profile_pic
        ? `${IDS.IMG_URL}${customerGet.profile_pic}`
        : "/assets/images/profile-icon.png";

      setProfileImage(img);
    }
  }, [customerGet]);

  /* -------------------- AUTO CLOSE MODAL -------------------- */
  useEffect(() => {
    if (showSuccess) {
      const timer = setTimeout(() => {
        setShowSuccess(false);
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [showSuccess]);

  useEffect(() => {
    if (showSuccess) {
      const timer = setTimeout(() => {
        setShowSuccess(false);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [showSuccess]);

  // const handleButtonClick = () => {
  //   if (isEditing) {
  //     console.log("Profile Saved!");
  //     setShowSuccess(true);
  //   }
  //   setIsEditing(!isEditing);
  // };

  // const handleFileChange = (event) => {
  //   const file = event.target.files[0];
  //   if (file) {
  //     const imageUrl = URL.createObjectURL(file);
  //     setProfileImage(imageUrl);
  //     console.log("File selected:", file.name);
  //   }
  // };

  useEffect(() => {
    if (customerGet && window.google && window.google.maps && mapRef.current) {
      initMap();
    }
  }, [customerGet]);

  // ✅ ADD THIS (already you have ref)
  const isEditingRef = useRef(false);

  // ✅ KEEP THIS (you already added)
  useEffect(() => {
    isEditingRef.current = isEditing;
  }, [isEditing]);

  // ✅ ADD THIS NEW EFFECT (IMPORTANT)
  useEffect(() => {
    if (markerRef.current) {
      markerRef.current.setDraggable(isEditing);
    }
  }, [isEditing]);
  useEffect(() => {
    if (
      mapInstance.current &&
      markerRef.current &&
      formData.lat &&
      formData.long
    ) {
      const position = {
        lat: parseFloat(formData.lat),
        lng: parseFloat(formData.long),
      };

      mapInstance.current.setCenter(position);
      markerRef.current.setPosition(position);
    }
  }, [formData.lat, formData.long]);

  const initMap = () => {
    // ✅ FIX: prevent error
    if (!mapRef.current) return;

    if (mapInstance.current) return;

    const position = {
      lat: parseFloat(formData.lat) || 18.5204,
      lng: parseFloat(formData.long) || 73.8567,
    };

    mapInstance.current = new window.google.maps.Map(mapRef.current, {
      center: position,
      zoom: 15,
    });

    markerRef.current = new window.google.maps.Marker({
      position: position,
      map: mapInstance.current,
      draggable: isEditingRef.current,
    });

    // Drag
    markerRef.current.addListener("dragend", (e) => {
      if (!isEditingRef.current) return;

      const lat = e.latLng.lat();
      const lng = e.latLng.lng();

      setFormData((prev) => ({
        ...prev,
        lat: lat.toString(),
        long: lng.toString(),
      }));
    });

    // Click
    mapInstance.current.addListener("click", (e) => {
      if (!isEditingRef.current) return;

      const lat = e.latLng.lat();
      const lng = e.latLng.lng();

      markerRef.current.setPosition({ lat, lng });

      setFormData((prev) => ({
        ...prev,
        lat: lat.toString(),
        long: lng.toString(),
      }));
    });

    initAutocomplete();
  };

  const initAutocomplete = () => {
    const autocomplete = new window.google.maps.places.Autocomplete(
      searchInputRef.current,
    );

    autocomplete.addListener("place_changed", () => {
      const place = autocomplete.getPlace();
      if (!place.geometry) return;

      const lat = place.geometry.location.lat();
      const lng = place.geometry.location.lng();

      mapInstance.current.setCenter({ lat, lng });
      markerRef.current.setPosition({ lat, lng });

      setFormData((prev) => ({
        ...prev,
        lat: lat.toString(),
        long: lng.toString(),
      }));

      searchInputRef.current.value = place.formatted_address;
    });
  };

  useEffect(() => {
    isEditingRef.current = isEditing;
  }, [isEditing]);

  /* -------------------- HANDLERS -------------------- */
  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({ ...prev, [name]: value }));

    // remove error instantly when user types
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };
  const handleButtonClick = async () => {
    if (!isEditing) {
      setIsEditing(true);
      return;
    }

    let newErrors = {};

    if (!formData.name) newErrors.name = "Full Name is required";
    if (!formData.email) newErrors.email = "Email is required";
    if (!formData.mobile_number)
      newErrors.mobile_number = "Mobile Number is required";
    if (!formData.adhar_no) newErrors.adhar_no = "Aadhar No is required";
    if (!formData.state_id) newErrors.state = "State is required";
    if (!formData.district_id) newErrors.district = "District is required";

    setErrors(newErrors);

    // अगर error है तो API call मत करो
    if (Object.keys(newErrors).length > 0) return;

    try {
      const sendData = new FormData();

      sendData.append("name", formData.name);
      sendData.append("email", formData.email);
      sendData.append("mobile_number", formData.mobile_number);
      sendData.append("whatsapp_no", formData.whatsapp_no || "");
      sendData.append("state_id", formData.state_id);
      sendData.append("district_id", formData.district_id);
      sendData.append("taluqa_id", formData.taluqa_id);
      sendData.append("area", formData.area);
      sendData.append("lat", formData.lat);
      sendData.append("long", formData.long);

      if (profilePicFile) {
        sendData.append("profile_pic", profilePicFile);
      }

      const res = await dispatch(Update_Customer(sendData));

      if (res.meta?.requestStatus === "fulfilled") {
        dispatch(GETCustomer());
        setShowSuccess(true);
        setIsEditing(false);
      }
    } catch (err) {
      console.error("Profile update failed", err);
    }
  };

  // const handleFileChange = (event) => {
  //   const file = event.target.files[0];
  //   if (file) {
  //     setProfileImage(URL.createObjectURL(file));
  //   }
  // };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setProfilePicFile(file);
      setProfileImage(URL.createObjectURL(file));
    }
  };

  const handleStateChange = (selectedOption) => {
    setFormData((prev) => ({
      ...prev,
      state: selectedOption,
      state_id: selectedOption?.value || null,
      district: null,
      district_id: null,
    }));

    setErrors((prev) => ({
      ...prev,
      state: "",
      district: "",
    }));

    if (selectedOption?.value) {
      dispatch(AllDistrict({ state_id: selectedOption.value }));
    }
  };

  const handleDistrictChange = (selectedOption) => {
    setFormData((prev) => ({
      ...prev,
      district: selectedOption,
      district_id: selectedOption?.value || null,
    }));

    setErrors((prev) => ({
      ...prev,
      district: "",
    }));
  };

  useEffect(() => {
    if (formData.district_id) {
      dispatch(AllTaluka({ district_id: formData.district_id }));
    }
  }, [formData.district_id, dispatch]);

  const handleTalukaChange = (selectedOption) => {
    setFormData((prev) => ({
      ...prev,
      taluka: selectedOption,
      taluqa_id: selectedOption?.value || null,
    }));

    setErrors((prev) => ({
      ...prev,
      taluka: "",
    }));
  };

  return (
    <div className="profile-wrapper">
      {userdata?.type === "customer" && (
        <div className="profile-container container">
          <div className="profile-card">
            {/* ---------------- PROFILE IMAGE ---------------- */}
            <div className="profile-image-wrapper">
              <input
                type="file"
                id="profile-image-upload"
                hidden
                accept="image/*"
                onChange={handleFileChange}
              />
              <img
                src={profileImage || "/assets/images/profile-icon.png"}
                alt="profile"
                className="profile-image"
              />
              <label htmlFor="profile-image-upload" className="edit-icon">
                <FontAwesomeIcon icon={faPencilAlt} />
              </label>
            </div>

            {/* ---------------- FORM ---------------- */}
            <div className="profile-form">
              <div className="form-row">
                <div className="form-group">
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    disabled={!isEditing}
                  />
                  {errors?.name && (
                    <span className="invalid-feedback d-block mb-4">
                      {errors.name}
                    </span>
                  )}
                  <label>Full Name</label>
                </div>

                <div className="form-group">
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                  />
                  {errors?.email && (
                    <span className="invalid-feedback d-block mb-4">
                      {errors.email}
                    </span>
                  )}
                  <label>Email</label>
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <input
                    type="text"
                    name="mobile_number"
                    value={formData.mobile_number}
                    onChange={handleInputChange}
                  />
                  {errors?.mobile_number && (
                    <span className="invalid-feedback d-block mb-4">
                      {errors.mobile_number}
                    </span>
                  )}
                  <label>Mobile Number</label>
                </div>

                <div className="form-group">
                  <input
                    type="number"
                    name="adhar_no"
                    value={formData.adhar_no}
                    onChange={handleInputChange}
                    disabled={!isEditing}
                  />
                  {errors?.adhar_no && (
                    <span className="invalid-feedback d-block">
                      {errors.adhar_no}
                    </span>
                  )}
                  <label>Adhaar No</label>
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <Select
                    value={formData.state}
                    options={states}
                    styles={selectStyles}
                    isDisabled={!isEditing}
                    onChange={handleStateChange}
                    placeholder=""
                  />
                  {errors?.state && (
                    <span className="invalid-feedback d-block">
                      {errors.state}
                    </span>
                  )}
                  <label className="floating-label">State</label>
                </div>

                <div className="form-group">
                  <Select
                    value={formData.district}
                    options={districts}
                    styles={selectStyles}
                    isDisabled={!isEditing || !formData.state}
                    onChange={handleDistrictChange}
                    placeholder=""
                  />
                  {errors?.district && (
                    <span className="invalid-feedback d-block">
                      {errors.district}
                    </span>
                  )}
                  <label className="floating-label">District</label>
                </div>

                <div className="form-group">
                  <Select
                    value={formData.taluka}
                    options={talukas}
                    styles={selectStyles}
                    isDisabled={!isEditing || !formData.district}
                    onChange={handleTalukaChange}
                    placeholder=""
                  />
                  {errors?.taluka && (
                    <span className="invalid-feedback d-block">
                      {errors.taluka}
                    </span>
                  )}
                  <label className="floating-label">Taluka</label>
                </div>
                <div className="form-group">
                  <input
                    type="text"
                    name="area"
                    value={formData.area}
                    onChange={handleInputChange}
                    disabled={!isEditing}
                  />
                  {errors?.area && (
                    <span className="invalid-feedback d-block">
                      {errors.area}
                    </span>
                  )}
                  <label>Area</label>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <input type="text" value={formData.lat} readOnly />
                    <label>Latitude</label>
                  </div>

                  <div className="form-group">
                    <input type="text" value={formData.long} readOnly />
                    <label>Longitude</label>
                  </div>
                </div>

                <div className="form-group">
                  <input
                    type="text"
                    ref={searchInputRef}
                    placeholder="Search Location"
                    disabled={!isEditing}
                  />
                </div>

                <div
                  ref={mapRef}
                  style={{
                    width: "100%",
                    height: "300px",
                    borderRadius: "10px",
                    marginTop: "10px",
                  }}
                />
              </div>

              <button
                className={isEditing ? "save-profile-btn" : "edit-profile-btn"}
                onClick={handleButtonClick}
              >
                {isEditing ? "Save Profile" : "Edit Profile"}
              </button>
            </div>
          </div>
        </div>
      )}
      {userdata?.type === "vendor" && <Profile_Vendor />}

      {userdata?.type === "expert" && <Profile_Expert />}

      <Account_Created_Modal
        showAccountModal={showSuccess}
        handleAccountModalClose={() => setShowSuccess(false)}
        text="Profile Saved Successfully!"
      />
    </div>
  );
};

export default Profile;
